import { useCallback, useEffect, useState } from 'react'

import { api, friendlyError, type ShipmentAttachment } from '../lib/api'

/**
 * The manager's files for the driver on one shipment. Pass null for a trip the driver has not
 * accepted: the server would answer 403, and there is nothing of the manager's to show yet.
 */
// refreshKey: the screen's own refresh. A file the logist adds after the driver accepted used to stay
// invisible until the block was mounted again, while the comment came with the shipment (Никита, 30.10.2026).
export function useDriverAttachments(shipmentId: string | null, refreshKey?: unknown) {
  const [items, setItems] = useState<ShipmentAttachment[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const load = useCallback(async (signal?: { cancelled: boolean }) => {
    if (!shipmentId) {
      setItems([])
      setError('')
      return
    }
    setLoading(true)
    setError('')
    try {
      const list = await api.listDriverAttachments(shipmentId)
      if (!signal?.cancelled) setItems(list)
    } catch (err) {
      if (!signal?.cancelled) setError(friendlyError(err, 'Не удалось загрузить файлы от логиста.'))
    } finally {
      if (!signal?.cancelled) setLoading(false)
    }
  }, [shipmentId])

  useEffect(() => {
    const signal = { cancelled: false }
    void load(signal)
    return () => {
      signal.cancelled = true
    }
  }, [load, refreshKey])

  return { items, loading, error, reload: () => load() }
}
